import * as React from 'react';
import {connect} from 'react-redux';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import {
    ParentDetails,
    IParentDetailsProps,
    CustomProps,
    ParentDetailsTypeEnum
} from 'components/Layout/DetailsSidebar/ParentDetails';
import {ActionDetailsIcon} from "HelperFunctions/DetailsSidebarHelpers";
import {submit} from "redux-form";
import * as VehiclesModule from "Modules/VehiclesModule";

interface IP extends IParentDetailsProps {
    edit: boolean;
    match?: any;
    formName: string;
}

interface IConnectedP {
    activeVehicleDetails: VehiclesModule.Types.CarDto;
}

interface IDispatchedP {
    t?: (key: string) => string;
    sendFormSubmit: (name: string) => void;
}

type S = {};

export class SimpleFormSendDetails extends ParentDetails<IP & IConnectedP & IDispatchedP, S> {
    constructor(props: IP & IConnectedP & IDispatchedP) {
        super(props);
    }

    public getCustomProps(): CustomProps {
        const {CARS_MANAGEMENT} = ViewManagementModule.EnumTypes.Page;

        return {
            ...(this.props as any),
            redirectUrlList: Dictionary.PageUrl.get(CARS_MANAGEMENT),
            type: ParentDetailsTypeEnum.SIDEBAR_ONE_ELEMENT
        };
    }

    private handleFormSend = () => {
        this.props.sendFormSubmit(this.props.formName)
    };

    public render() {
        const {t} = this.props;
        return <div className="details-right__dashboard">
            <>
                <ActionDetailsIcon active iconSrc={`/images/icons/save.svg`} title={t('forms:send')}
                                   e2eId={"saveBtn"} onClick={this.handleFormSend}/>

                <ActionDetailsIcon active iconSrc={`/images/icons/red_cros.svg`}
                                   title={t('forms:cancel')}
                                   e2eId={"cancelBtn"} onClick={() => this.cancelClick()}/>
            </>
        </div>
    }
}

function mapStateToProps(state: any): IConnectedP {
    return {
        activeVehicleDetails: state.vehiclesStore.activeVehicleDetails,
    };
}

function mapDispatchToProps(dispatch: any): IDispatchedP {
    return {
        sendFormSubmit: (name: string) => dispatch(submit(name))
    }
}

export default withTranslation(['carDetails', 'forms'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SimpleFormSendDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Contract/SimpleFormSendDetails.tsx